function refusedToken(res, body) {
    return res.status === 401 && "error" in body && body.error.code === "UNAUTHENTICATED";
}
/**
 * One call to our APIs, read through the `{ success, data | error }` envelope. `send` is called
 * with whether to force-refresh the ID token it sends.
 *
 * An authenticated call refused with 401 UNAUTHENTICATED is sent once more on a fresh token: the
 * server answers the same when verifying a sound token fails for a moment. Only when the retry is
 * refused too is the session dead (revoked, or the emulator reset or reseeded), and `sessionEnded`
 * tells the app to sign out.
 */
export async function callApi(send, authenticated) {
    const read = async (res) => (await res.json().catch(() => ({})));
    let res = await send(false);
    let body = await read(res);
    if (authenticated && refusedToken(res, body)) {
        res = await send(true);
        body = await read(res);
    }
    if (res.ok && !("success" in body && body.success === false)) {
        return { ok: true, data: body.data };
    }
    const err = "error" in body ? body.error : { code: "UNKNOWN", message: res.statusText };
    return {
        ok: false,
        status: res.status,
        code: err.code,
        message: err.message,
        sessionEnded: authenticated && refusedToken(res, body),
    };
}
